export const socials = [
  {
    href: 'https://www.facebook.com/KiaSweden/',
    icon: 'https://img.icons8.com/?size=100&id=13912&format=png&color=000000',
    alt: 'Facebook',
  },
  {
    href: 'https://www.linkedin.com/company/kia-sweden-ab/',
    icon: 'https://img.icons8.com/?size=100&id=13930&format=png&color=000000',
    alt: 'LinkedIn',
  },
  {
    href: 'https://www.instagram.com/kiasweden/',
    icon: 'https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000',
    alt: 'Email',
  },
];

export const links = [
  {
    href: 'https://www.dropbox.com/scl/fi/u4mmz4gcpy3q1ve0h4w9l/Info-bro-FJM-2024-web.pdf?rlkey=7buvb541snkx1nwel90q454d3&dl=0',
    text: 'Schema 27/7 till 3/8',
  },

  {
    href: 'https://www.kia.com/se/nya-bilar/ev9/upptack/',
    text: 'Kia EV9',
  },
  {
    href: 'https://www.kia.com/se/nya-bilar/ev6/upptack/',
    text: 'Kia EV6',
  },
  {
    href: 'https://www.kia.com/se/nya-bilar/sorento-plug-in-hybrid/upptack/',
    text: 'Kia Sorento Plug-In Hybrid',
  },
  {
    href: 'https://www.kia.com/se/nya-bilar/sportage/upptack/',
    text: 'Kia Sportage Plug-In Hybrid',
  },
  {
    href: 'https://www.kia.com/se/broschyr/#/',
    text: 'Ladda ned faktablad',
  },
  {
    href: 'https://www.kia.com/se/tjanstebil/',
    text: 'Kia som tjänstebil',
  },
  {
    href: 'https://www.kia.com/se/om-kia/upplev-kia/varumarke/sponsorskap/fjallmaraton/',
    text: 'Kia Fjällmaraton',
  },
];
